import { IconButton, Typography } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import styles from "../../organisms/filterWindow/styles.module.scss";
import { useTableContext } from "../../../context/tableContext";

export const FilterHeader = () => {
  const { setOpenFilter,setApplyRole } = useTableContext();
  return (
    <div className={`${styles.container}`} >
      <Typography className={`filter-header ${styles.title}`}>Filters</Typography>
      <IconButton>
        <CloseIcon
          onClick={() => {
            setOpenFilter(false);
            setApplyRole(false)
          }}
          className="close-icon"
        />
      </IconButton>
    </div>
  );
};
